export default "b8a0249df89fb2e2.svg"